import React from "react";
import { useState } from "react";
import "../../Styles/BoxBashgah.css";

const BoxBashgah = ({ title, info }) => {
  const [number, setNumbeer] = useState(true);
  return (
    <div className="Bashgah-inside-item4-right-box-inside">
      <div className="Bashgah-inside-item4-right-box-inside-box-top-border">
        <div className="Bashgah-inside-item4-right-box-inside-box-top">
          <div className="Bashgah-inside-item4-right-box-inside-box-top-inside">
            <p className="Bashgah-inside-item4-right-box-inside-box-top-inside-text">
              {title}
            </p>
          </div>
        </div>
      </div>
      <div className="Bashgah-inside-item4-right-box-inside-box">
        <div className="Bashgah-inside-item4-right-box-inside-box-inside">
          {number ? (
            <div>
              {info.bests?.slice(0, 3).map((item, i) => (
                <div className="Bashgah-inside-item4-right-box-inside-box-inside-border">
                  <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-inside">
                    <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-image">
                      <img
                        className="Bashgah-inside-item4-right-box-inside-box-inside-border-image-img"
                        src={`/imgs/Bashgah/num-${i + 1}.svg`}
                      />
                    </div>
                    <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile">
                      <img
                        className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile-img"
                        src={item.avatar || "/imgs/Bashgah/bashgah-profile.svg"}
                      />
                    </div>
                    <p className="Bashgah-inside-item4-right-box-inside-box-inside-border-name">
                      {/* {item.name} */}
                      {document.body.clientWidth > 480 &&
                      item.name.length > 20 ? (
                        <div>
                          <marquee width="100%" direction="right">
                            <p style={{ width: "100%" }}>{item.name}</p>
                            {console.log("pc size")}
                          </marquee>
                        </div>
                      ) : document.body.clientWidth < 480 &&
                        item.name.length > 17 ? (
                        <marquee
                          scrollamount="4"
                          width="100%"
                          direction="right"
                        >
                          <p style={{ width: "100%" }}>{item.name}</p>
                          {console.log("mob size")}
                        </marquee>
                      ) : (
                        item.name
                      )}
                    </p>
                    <div className="Bashgah-inside-item4-box-inside-border-left">
                      <img
                        src={
                          item.score
                            ? "/imgs/bashgah/nafaratBartar.svg"
                            : item.numberOfInvite
                            ? "/imgs/bashgah/iconDavat.svg"
                            : item.numberOfLike
                            ? "/imgs/bashgah/iconLike.svg"
                            : null
                        }
                      />

                      <p className="number-font">
                        {item.score}
                        {item.numberOfInvite}
                        {item.numberOfLike}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              {info?.bests?.length > 3 && (
                <div
                  className="Bashgah-button"
                  onClick={() => setNumbeer(!number)}
                >
                  <button className="Bashgah-button-inside">
                    <img
                      style={{ rotate: "180deg" }}
                      src="/imgs/bashgah/button.svg"
                    />
                    <p>دیدن ادامه</p>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div>
              {info.bests?.slice(0, 10).map((item, i) => (
                <div className="Bashgah-inside-item4-right-box-inside-box-inside-border">
                  <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-inside">
                    <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-image">
                      <img
                        className="Bashgah-inside-item4-right-box-inside-box-inside-border-image-img"
                        src={`/imgs/Bashgah/num-${i + 1}.svg`}
                      />
                    </div>
                    <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile">
                      <img
                        className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile-img"
                        src={item.avatar || "/imgs/Bashgah/bashgah-profile.svg"}
                      />
                    </div>
                    <p className="Bashgah-inside-item4-right-box-inside-box-inside-border-name">
                      {document.body.clientWidth > 480 &&
                      item.name.length > 20 ? (
                        <div>
                          <marquee width="100%" direction="right">
                            <p style={{ width: "100%" }}>{item.name}</p>
                            {console.log("pc size")}
                          </marquee>
                        </div>
                      ) : document.body.clientWidth < 480 &&
                        item.name.length > 17 ? (
                        <marquee
                          scrollamount="4"
                          width="100%"
                          direction="right"
                        >
                          <p style={{ width: "100%" }}>{item.name}</p>
                          {console.log("mob size")}
                        </marquee>
                      ) : (
                        item.name
                      )}
                    </p>
                    <div className="Bashgah-inside-item4-box-inside-border-left">
                      <img
                        src={
                          item.score
                            ? "/imgs/bashgah/nafaratBartar.svg"
                            : item.numberOfInvite
                            ? "/imgs/bashgah/iconDavat.svg"
                            : item.numberOfLike
                            ? "/imgs/bashgah/iconLike.svg"
                            : null
                        }
                      />

                      <p className="number-font">
                        {item.score}
                        {item.numberOfInvite}
                        {item.numberOfLike}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              <div
                className="Bashgah-button"
                onClick={() => setNumbeer(!number)}
              >
                <button className="Bashgah-button-inside">
                  <img src="/imgs/bashgah/button.svg" />
                  <p>بستن</p>
                </button>
              </div>
            </div>
          )}
          {/* {info.bests?.slice(0, 3).map((item, i) => (
            <div className="Bashgah-inside-item4-right-box-inside-box-inside-border">
              <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-inside">
                <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-image">
                  <img
                    className="Bashgah-inside-item4-right-box-inside-box-inside-border-image-img"
                    src={`/imgs/Bashgah/num-${i + 1}.svg`}
                  />
                </div>
                <div className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile">
                  <img
                    className="Bashgah-inside-item4-right-box-inside-box-inside-border-profile-img"
                    src={"/imgs/Bashgah/bashgah-profile.svg" || item.avatar}
                  />
                </div>
                <p className="Bashgah-inside-item4-right-box-inside-box-inside-border-name">
                  {item.name}
                </p>
                <div className="Bashgah-inside-item4-box-inside-border-left">
                  <img 
                  src={item.score  ? "/imgs/bashgah/nafaratBartar.svg" : 
                  item.numberOfInvite ? "/imgs/bashgah/iconDavat.svg" :  
                  item.numberOfLike ? "/imgs/bashgah/iconLike.svg" : 
                  null}/>

                  <p className="number-font">
                    {item.score}
                    {item.numberOfInvite}
                    {item.numberOfLike}
                  </p>
                </div>

              </div>
            </div>
          ))} */}
        </div>
      </div>

      <p className="Bashgah-inside-item4-right-box-inside-box-inside-rank">
        رتبه تو در لیست:
        <span className="Bashgah-inside-item4-right-box-inside-box-inside-rank-number number-font">
          {info.yourLevel === null ? "رتبه ای ندارید" : info.yourLevel}
        </span>
      </p>
    </div>
  );
};

BoxBashgah.defaultProps = {
  info: {},
};

export default BoxBashgah;
